import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { QRCode } from "antd/lib";
import { ParticipantsIpmService } from "../../Services/ParticipantsIpmService";
import {
  Button,
  Card,
  Col,
  message,
  Modal,
  Progress,
  Row,
  Space,
  Table,
  Tabs,
  Tag,
  Upload,
} from "antd";
import TabPane from "antd/es/tabs/TabPane";
import { FamilleService } from "../../Services/FamilleService";
import avatar from "../Image/avatar.jpg";
import Exercice from "../Exercice";
import SelectDoc from "../SelectDoc";
import {
  CloudDownloadOutlined,
  DeleteOutlined,
  UploadOutlined,
} from "@ant-design/icons";

const DetailsParticipant = () => {
  const { numcont } = useParams();
  const [familleData, setFamilleData] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState("AAA");
  const [documents, setDocuments] = useState([]);
  const [piecejointes, setPieceJointes] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [participantData, setParticipantData] = useState(null);
  const [img, setImg] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false); // Etat pour gérer la visibilité du modal
  const [fileList, setFileList] = useState([]);

  const benefService = new FamilleService();
  const participantsIpmService = new ParticipantsIpmService();

  const defaultAvatar = avatar;

  const showModal = () => {
    setIsModalVisible(true);
  };

  // Fonction pour fermer le modal
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Fonction pour gérer l'upload des fichiers
  const handleUpload = ({ fileList }) => {
    setFileList(fileList);
  };

  // Fonction pour gérer l'enregistrement des fichiers via l'API
  const handleUploadFile = async () => {
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("files", file.originFileObj); // Ajouter les fichiers binaires au payload
    });

    try {
      // Appel de l'API pour enregistrer les fichiers en tant que binary
      await participantsIpmService.importpiecejointe(numcont, formData);
      message.success("Fichiers téléversés avec succès.");
      handleCancel(); // Fermer le modal après succès
      fetchPieceJointes();
    } catch (error) {
      message.error("Erreur lors du téléversement des fichiers.");
      console.error(error);
    }
  };

  // Supprimer un fichier
  const handleDeleteFile = async (file_id) => {
    try {
      await participantsIpmService.deletepiecejointe(file_id);
      message.success("Fichier supprimé avec succès.");
      setPieceJointes((prev) =>
        prev.filter((item) => item.file_id !== file_id)
      ); // Supprimer le fichier localement après succès
    } catch (error) {
      message.error("Erreur lors de la suppression du fichier.");
      console.error(error);
    }
  };

  // Télécharger un fichier
  const handleDownloadFile = async (file_id, file_name) => {
    try {
      const response = await participantsIpmService.downloadpiecejointe(
        file_id
      );

      // Détecter le type de fichier à partir de l'extension du nom de fichier
      const fileExtension = file_name.split(".").pop().toLowerCase();

      let blob;

      // Vérifier le type de fichier et configurer le type MIME approprié
      if (fileExtension === "pdf") {
        blob = new Blob([response], { type: "application/pdf" });
      } else if (fileExtension === "xlsx") {
        blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      } else {
        message.error("Type de fichier non pris en charge.");
        return;
      }

      const url = window.URL.createObjectURL(blob);

      // Ouvrir dans une nouvelle fenêtre pour les PDF, sinon télécharger les autres fichiers
      if (fileExtension === "pdf") {
        window.open(url); // Ouvre le PDF dans une nouvelle fenêtre ou onglet
      } else if (fileExtension === "xlsx") {
        const a = document.createElement("a");
        a.href = url;
        a.download = file_name; // Télécharger le fichier avec le nom d'origine
        a.click();
        window.URL.revokeObjectURL(url);
      }

      message.success("Fichier téléchargé avec succès.");
    } catch (error) {
      message.error("Erreur lors du téléchargement du fichier.");
      console.error(error);
    }
  };

  // Récupérer les ayants droit et les informations du participant
  useEffect(() => {
    const fetchParticipantData = async () => {
      try {
        const familleData = await benefService.getAllBeneciaire(numcont);
        setFamilleData(familleData);

        const participantData =
          await participantsIpmService.getOneListParticipant(numcont);
        setParticipantData(participantData);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des ayants droits",
          error
        );
      }
    };

    if (numcont) {
      fetchParticipantData();
    }
  }, [numcont]);

  // Récupérer l'image du participant
  useEffect(() => {
    /* const fetchImage = async () => {
      const res = await fetch(
        `https://ipm-sentenac.com/office/api/Participant/getPhoto/${numcont}`
      );
      const imageBlob = await res.blob();
      const imageObjectURL = URL.createObjectURL(imageBlob);
      setImg(imageObjectURL);
    };

    if (numcont) {
      fetchImage();
    } */
    const fetchImg = async () => {
      console.log(numcont);

      try {
        const image = await participantsIpmService.fetchImgDetail(numcont);
        if (image) {
          setImg(image);
        } else {
          console.error("Image non trouvée ou matripart incorrect");
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };
    if (numcont) {
      fetchImg();
    }
  }, [numcont]);

  const filteredFamilleData = familleData.filter(
    (item) => item.codebenef !== "1"
  );
  const nbrenf = filteredFamilleData.reduce(
    (sum, record) => sum + (record.codebenef === "3" ? 1 : 0),
    0
  );
  const nbrfem = filteredFamilleData.reduce(
    (sum, record) => sum + (record.codebenef === "2" ? 1 : 0),
    0
  );
  const epoux = filteredFamilleData.reduce(
    (sum, record) => sum + (record.codebenef === "4" ? 1 : 0),
    0
  );

  // Récupérer les documents en fonction de l'année sélectionnée
  const fetchDocuments = async (year) => {
    try {
      const data = await participantsIpmService.documentList(numcont, year);
      setDocuments(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des documents :", error);
    }
  };
  const fetchPieceJointes = async () => {
    try {
      const data = await participantsIpmService.piecejointes(numcont);
      setPieceJointes(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des documents :", error);
    }
  };
  useEffect(() => {
    fetchPieceJointes();
  }, []);

  // Cette fonction est appelée uniquement lorsque l'utilisateur change l'année
  const handleExerciceChange = (year) => {
    if (year && year !== selectedYear) {
      // S'assure que l'année est nouvelle avant de faire l'appel
      setSelectedYear(year); // Mettre à jour l'année sélectionnée
      fetchDocuments(year); // Charger les documents pour cette année
    }
  };

  // Ne pas appeler fetchDocuments tant que selectedYear est null
  useEffect(() => {
    if (numcont && selectedYear) {
      fetchDocuments(selectedYear); // Charger les documents lorsque l'année et le participant changent
    }
  }, [numcont, selectedYear]);

  if (!participantData) {
    return <div>Chargement en cours...</div>;
  }

  const onchangeDoc = (value) => setSelectedDoc(value);

  // Colonnes pour la table des ayants droit
  const columns = [
    {
      title: "Matricule",
      dataIndex: "matribenef",
      key: "matribenef",
      align: "center",
    },
    {
      title: "Type Benef",
      dataIndex: "codebenef",
      key: "codebenef",
      render: (text) => {
        const typeBenef = {
          2: "Epouse",
          3: "Enfant",
          4: "Epoux",
          5: "Ascendant",
          6: "Autre",
        };
        return <span>{typeBenef[text] || "Inconnu"}</span>;
      },
    },
    { title: "Prénom(s)", dataIndex: "prenoms", key: "prenoms" },
    { title: "Nom", dataIndex: "nom", key: "nom" },
    { title: "Adresse", dataIndex: "adresse", key: "adresse" },
    {
      title: "Lieu naissance",
      dataIndex: "lieunaiss",
      key: "lieunaiss",
    },
    { title: "Age", dataIndex: "ageb", key: "ageb" },
    { title: "Sexe", dataIndex: "sexe", key: "sexe", align: "center" },
    {
      title: "Etat",
      dataIndex: "suspension_benef",
      key: "suspension_benef",
      align: "center",
      render: (text) => {
        const tagColor = {
          A: "#46de04",
          S: "#f2b305",
          R: "#fa0202",
          W: "#0570f2",
        };
        const tagText = {
          A: "Actif",
          S: "Suspendu",
          R: "Résilié",
          W: "En cours",
        };
        return (
          <Tag color={tagColor[text] || "gray"}>
            {tagText[text] || "Inconnu"}
          </Tag>
        );
      },
    },
    { title: "Majorité", dataIndex: "majorite", key: "majorite" },
    {
      title: "Durée Prog",
      dataIndex: "duree_prog",
      key: "duree_prog",
      align: "center",
    },
  ];

  // Colonnes pour les documents
  const documentColumns = [
    { title: "Numero", dataIndex: "numdoc", key: "numdoc", align: "center" },
    { title: "Type", dataIndex: "typedoc", key: "typedoc" },
    { title: "Date", dataIndex: "datedoc", key: "doc" },
    { title: "Type bénéf", dataIndex: "typebenef", key: "typebenef" },
    { title: "Bénéficiaire", dataIndex: "beneficiaire", key: "beneficiaire" },
    { title: "Prestataire", dataIndex: "fournisseur", key: "fournisseur" },
    {
      title: "Etat",
      dataIndex: "etat",
      key: "etat",
      align: "center",
      render: (text) => {
        const tagColor = {
          OK: "#46de04",
          KO: "#f2b305",
        };
        const tagText = {
          OK: "traité",
          KO: "En cour",
        };
        return (
          <Tag color={tagColor[text] || "gray"}>
            {tagText[text] || "Inconnu"}
          </Tag>
        );
      },
    },
  ];
  const piecesjointesColumns = [
    { title: "Numéro", dataIndex: "file_id", key: "file_id", align: "center" },
    { title: "Nom du fichier", dataIndex: "file_name", key: "file_name" },
    { title: "Type", dataIndex: "file_type", key: "file_type" },
    {
      title: "Taille (Ko)",
      dataIndex: "file_size",
      key: "file_size",
      align: "center",
    },
    {
      // title: "Action",
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      align: "center",
      fixed: "right",
      render: (text, record) => (
        <Space>
          <Button
            type="text"
            icon={
              <CloudDownloadOutlined
                style={{ cursor: "pointer", color: "green" }}
              />
            }
            onClick={() => handleDownloadFile(record.file_id, record.file_name)}
          />
          <Button
            type="text"
            icon={
              <DeleteOutlined style={{ cursor: "pointer", color: "red" }} />
            }
            onClick={() => handleDeleteFile(record.file_id)}
          />
        </Space>
      ),
    },
  ];
  return (
    <div>
      <h3>
        {participantData.matipm}: {participantData.prenom} {participantData.nom}
      </h3>
      <Row gutter={16}>
        <Col span={8}>
          {/*   <Space>
            <img
              src={defaultAvatar || img}
              alt="avatar"
              style={{
                width: "70%",
                height: "auto",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
            <QRCode
              value={`Contenu du code QR pour ${participantData.matipm}`}
              size={200}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          </Space> */}

          <Card
            hoverable
            style={{ width: "100%", textAlign: "left", padding: 12 }}
            cover={
              <Space
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <img
                  src={img || defaultAvatar}
                  onError={(e) => {
                    e.target.src = defaultAvatar; // Remplace par defaultAvatar si l'image échoue
                  }}
                  alt="avatar"
                  style={{
                    width: "100%",
                    height: 200,
                    objectFit: "contain", // Utilisez 'contain' au lieu de 'cover'
                    borderRadius: "8px 8px 8px 8px",
                  }}
                />

                <QRCode
                  value={`Contenu du code QR pour ${participantData.matipm}`}
                  //size={175}
                  style={{
                    width: "75%",
                    height: "auto",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </Space>
            }
          >

          </Card>
        </Col>
        <Col span={6}>
          {participantData && (
            <div>
              <span>
                <b>CIN :</b>
              </span>{" "}
              {participantData.cin}
              <br />
              <span>
                <b>Prénom & Nom :</b>
              </span>{" "}
              {participantData.prenom} {participantData.nom}
              <br />
              <span>
                <b>Adresse :</b>
              </span>{" "}
              {participantData.adresse}
              <br />
              <span>
                <b>Mobile:</b>
              </span>{" "}
              {participantData.portable}
              <br />
              <span>
                <b>Email :</b>
              </span>{" "}
              {participantData.email}
              <br />
              <span>
                <b>Situation familiale :</b>
              </span>{" "}
              {participantData.sitfam}
              <br />
              <span>
                <b>Date de naissance :</b>
              </span>{" "}
              {participantData.datenaiss}
              <br />
              <span>
                <b>Lieu de naissance:</b>
              </span>{" "}
              {participantData.lieunaiss}
              <br />
              <span>
                <b>Matricule :</b>
              </span>{" "}
              {participantData.matmut}
              <br />
            </div>
          )}
        </Col>
        <Col span={8}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Progress
                style={{ width: 500 }}
                percent={participantData.conso}
                status="active"
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "100px",
              }}
            >
              <Space>
                <Button onClick={showModal} className="Buttonvalid">
                  Joindre pièce
                </Button>
                <Link to="/Participants">
                  <Button className="buttonCompta">Retour</Button>
                </Link>
              </Space>
            </div>
          </Space>
        </Col>
      </Row>

      <Tabs
        defaultActiveKey="1"
        size="small"
        tabBarStyle={{
          background: "#010f1c",
          color: "#ffff",
          marginBottom: "16px",
        }}
        tabBarGutter={8}
        tabPosition="top"
      >
        <TabPane
          tab={<span className="whiteTextTab">Ayants droits</span>}
          key="1"
        >
          <Card
            title={`Age Participant: ${participantData.agepart
              } - Nb. Epoux(se): ${nbrfem > 0 ? nbrfem : epoux
              } - Nb. Enfants: ${nbrenf}`}
          >
            <Table
              showSorterTooltip={false}
              dataSource={familleData.filter((item) => item.codebenef !== "1")}
              columns={columns}
              scroll={{ x: true }}
              style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
              className="custom-header1-table"
              bordered
              rowKey="matribenef"
            />
          </Card>
        </TabPane>

        <TabPane tab={<span className="whiteTextTab">Documents</span>} key="2">
          <Card
            title="Documents du participant"
            extra={
              <Row gutter={12}>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <Exercice onExerciceChange={handleExerciceChange} />
                </Col>
                <Col xs={24} sm={12} md={12} lg={8}>
                  <SelectDoc
                    defaultValue={selectedDoc}
                    onChange={onchangeDoc}
                  />
                </Col>
              </Row>
            }
          >
            <Table
              showSorterTooltip={false}
              dataSource={documents}
              columns={documentColumns}
              scroll={{ x: true }}
              style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
              className="custom-header1-table"
              bordered
              rowKey="numdoc"
            />
          </Card>
        </TabPane>

        <TabPane
          tab={<span className="whiteTextTab">Pieces Jointes</span>}
          key="3"
        >
          <Card>
            <Table
              showSorterTooltip={false}
              columns={piecesjointesColumns}
              dataSource={piecejointes}
              scroll={{ x: true }}
              style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
              className="custom-header1-table"
              bordered
            />
          </Card>
        </TabPane>
      </Tabs>

      <Modal
        title="Importer un fichier"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Upload
          fileList={fileList}
          onChange={handleUpload}
          beforeUpload={() => false}
        >
          <Button icon={<UploadOutlined />}>Sélectionner un fichier</Button>
        </Upload>
        <Button
          type="primary"
          onClick={handleUploadFile}
          style={{ marginTop: 16 }}
        >
          Téléverser
        </Button>
      </Modal>
    </div>
  );
};

export default DetailsParticipant;
